import * as types from "./actionTypes";
import {BezoekerTabs} from "../constants/DomainConstants";

export function updateModel(tab, model) {
    return {
        type: types.UPDATE_NIEUWESPORTCLUB_MODEL,
        body: {
            tab: tab,
            model: model
        }
    };
}

export function organisatieModelUpdate(model) {
    return function (dispatch) {
        const tab = BezoekerTabs.ORGANISATIEGEGEVENS.tab;

        return dispatch(updateModel(tab, model));
    };
}

export function identificatieModelUpdate(model) {
    return function (dispatch) {
        const tab = BezoekerTabs.IDENTIFICATIEGEGEVENS.tab;

        return dispatch(updateModel(tab, model));
    };
}

export function sporttakkenModelUpdate(model) {
    return function (dispatch) {
        const tab = BezoekerTabs.SPORTTAKKEN.tab;

        return dispatch(updateModel(tab, model));
    };
}

export function adresModelUpdate(model) {
    return function (dispatch) {
        const tab = BezoekerTabs.ADRESSEN.tab;

        return dispatch(updateModel(tab, model));
    };
}

export function doelgroepModelUpdate(model) {
    return function (dispatch) {
        const tab = BezoekerTabs.DOELGROEPEN.tab;

        return dispatch(updateModel(tab, model));
    };
}

export function socialeMediaModelUpdate(model) {
    return function (dispatch) {
        const tab = BezoekerTabs.SOCIALE_MEDIA.tab;

        return dispatch(updateModel(tab, model));
    };
}

export function andereOpmerkingModelUpdate(model) {
    return function (dispatch) {
        const tab = "andereOpmerking";

        return dispatch(updateModel(tab, model));
    };
}